// src/utils/globalErrorTracker.js
import { logger } from "./logger";

export const setupGlobalErrorTracking = () => {
  window.onerror = function (msg, url, lineNo, columnNo, error) {
    logger.error("Global JS Error", {
      message: msg,
      url,
      lineNo,
      columnNo,
      stack: error?.stack,
    });
  };

  window.onunhandledrejection = function (event) {
    logger.error("Unhandled Promise Rejection", {
      reason: event.reason?.toString(),
      stack: event.reason?.stack,
    });
  };
};
